import createReactComponent from '../createReactComponent';
export default createReactComponent('kanban', 'Kanban', [["path",{"d":"M6 5v8m6-8v13.5M18 5v9","key":"svg-0"}]]);